<template>
  <div class="background-login">
    <notifications></notifications>
    <transition name="loader">
      <loader v-show="flagLoading" />
    </transition>
    <div class="form-login">
      <div class="leftPage">
        <header class="logoPage">
          <img
            src="../../../public/img/Logo.png"
            style="width: 15vw"
            class="logoImg"
          />
          <div class="welcomePage">
            <h4 class="titleSlogan">HỆ THỐNG QUẢN LÝ BÁN HÀNG</h4>
            <p class="slogan">CHÀO MỪNG BẠN ĐẾN VỚI HỆ THỐNG</p>
            <p class="slogan">HỖ TRỢ QUẢN LÝ BÁN HÀNG</p>
          </div>
        </header>
      </div>
      <div class="rightPage">
        <header class="rightLogo md-elevation-4">
          <img src="../../../public/img/Logo.png" class="logoImg" />
        </header>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <md-card class="formLogin">
              <!-- <md-card-header>
                <div class="headerLogin">
                  <md-icon>contacts</md-icon>
                </div>
              </md-card-header> -->

              <md-card-content>
                <ValidationProvider
                  name="email"
                  rules="required|email"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-input
                      v-model="email"
                      type="email"
                      placeholder="Địa chỉ email"
                    ></md-input>

                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </ValidationProvider>

                <ValidationProvider
                  name="password"
                  rules="required|min:5"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <md-input
                      v-model="password"
                      type="password"
                      palceholder="Mật khẩu"
                    ></md-input>

                    <slide-y-down-transition>
                      <md-icon class="error" v-show="failed">close</md-icon>
                    </slide-y-down-transition>
                    <slide-y-down-transition>
                      <md-icon class="success" v-show="passed">done</md-icon>
                    </slide-y-down-transition>
                  </md-field>
                </ValidationProvider>
              </md-card-content>

              <md-card-actions>
                <md-button
                  :disabled="flagLoading"
                  type="submit"
                  class="btnLogin"
                  style="width: 100%"
                  ><md-progress-spinner
                    :md-diameter="20"
                    :md-stroke="2"
                    md-mode="indeterminate"
                    style="margin-right: 10px"
                    v-show="flagLoading"
                  ></md-progress-spinner>
                  Đăng nhập</md-button
                >
              </md-card-actions>
            </md-card>
          </form>
        </ValidationObserver>
        <multi-factor-dialog
          v-if="showDialog"
          :showDialog="showDialog"
          :resolver="resolver"
          @closeDialog="showDialog = false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { LoginCard, Loader } from "@/components";
import Notifications from "@/components";
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import firebase from "@/services/firebase-init.js";
import "firebase/auth";
require("firebase/firestore");

extend("email", email);
extend("required", required);
extend("min", min);
export default {
  name: "Login",
  components: {
    SlideYDownTransition,
    Loader,
    MultiFactorDialog: () => import("./MultiFactorDialog"),
  },
  computed: {
    ...mapGetters(["flagLoading"]),
  },
  data() {
    return {
      showDialog: false,
      db: null,
      messaging: null,
      email: null,
      password: null,
      listUser: [],
      resolver: null,
    };
  },
  async created() {
    this.db = firebase.firestore();
    let self = this;

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then(async (idTokenResult) => {
            console.log(idTokenResult);
            localStorage.clear();
            try {
              let adminHPDoc = null;
              adminHPDoc = await this.db
                .collection(process.env.VUE_APP_ADMIN + "HP")
                .where("email", "==", user.email)
                .get();
              if (adminHPDoc.size !== 0) localStorage.setItem("bits", "HP");
              else {
                const adminDoc = await this.db
                  .collection(process.env.VUE_APP_ADMIN)
                  .where("email", "==", user.email)
                  .get();
                if (adminDoc.size !== 0) localStorage.setItem("bits", "");
                else if (idTokenResult.claims.HP)
                  localStorage.setItem("bits", "HP");
                else localStorage.setItem("bits", "");
              }
            } catch (error) {
              console.log(error);
            }
            if (firebase.messaging.isSupported()) {
              let bits = localStorage.getItem("bits");
              this.messaging = await firebase.messaging();
              this.messaging
                .getToken()
                .then(async (currentToken) => {
                  if (currentToken) {
                    const adminRef = firebase
                      .firestore()
                      .collection("--stats--")
                      .doc(process.env.VUE_APP_ADMIN_TOKEN + bits);
                    const adminRes = await adminRef.update({
                      tokens:
                        firebase.firestore.FieldValue.arrayUnion(currentToken),
                    });
                  } else {
                    console.log(
                      "No Instance ID token available. Request permission to generate one."
                    );
                  }
                })
                .catch((err) => {
                  console.log(
                    "An error occurred while retrieving token. ",
                    err
                  );
                });
            }
            if (!!idTokenResult.claims.admin) {
              let bits = localStorage.getItem("bits");
              await this.db
                .collection(process.env.VUE_APP_ADMIN + bits)
                .where("email", "==", user.email)
                .get()
                .then((doc) => {
                  doc.forEach((item) => {
                    localStorage.setItem("permission", item.data().permission);
                    self.$router.push("/" + item.data().permission[0]);
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
            } else if (!!idTokenResult.claims.root) {
              localStorage.setItem(
                "permission",
                "manage-products,customer-management,warehouse-management,user-management,news-managements,bill-management,admin-management"
              );
              console.log("pushing " + localStorage.getItem("permission"));

              self.$router.push({
                name: "Quản lý đơn hàng",
              });
            } else {
              alert("Bạn không có quyền truy cập trang này");
              firebase
                .auth()
                .signOut()
                .then(function () {
                  self.$router.push("/");
                })
                .catch(function (error) {});
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  },
  methods: {
    submit() {
      this.$store.dispatch("FLAG_LOADING", true);

      // firebase
      //   .auth()
      //   .signInWithEmailAndPassword(this.email, this.password)
      //   .then(res => {
      //     this.$store.dispatch("FLAG_LOADING", false);
      //   })
      //   .catch(error => {
      //     // Handle Errors here.
      //     this.$store.dispatch("FLAG_LOADING", false);
      //     var errorCode = error.code;
      //     var errorMessage = error.message;
      //     if (
      //       errorCode == "auth/wrong-password" ||
      //       errorCode == "auth/user-not-found"
      //     ) {
      //       this.$messageError("Sai tên đăng nhập hoặc mật khẩu");
      //     } else if (errorCode == "auth/user-disabled") {
      //       this.$messageError("Tài khoản của bạn đã bị khóa");
      //     } else {
      //       console.log(error);
      //     }
      //   });

      var resolver;
      var _this = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(function (userCredential) {
          // User is not enrolled with a second factor and is successfully signed in.
          // ...
        })
        .catch(function (error) {
          if (error.code == "auth/multi-factor-auth-required") {
            _this.resolver = error.resolver;
            _this.showDialog = true;

            // Ask user which second factor to use.
            // if (resolver.hints[selectedIndex].factorId ===
            //     firebase.auth.PhoneMultiFactorGenerator.FACTOR_ID) {
            //   var phoneInfoOptions = {
            //     multiFactorHint: resolver.hints[selectedIndex],
            //     session: resolver.session
            //   };
            //   var phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
            //   // Send SMS verification code
            //   return phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, appVerifier)
            //     .then(function(verificationId) {
            //       // Ask user for the SMS verification code.
            //       var cred = firebase.auth.PhoneAuthProvider.credential(
            //           verificationId, verificationCode);
            //       var multiFactorAssertion =
            //           firebase.auth.PhoneMultiFactorGenerator.assertion(cred);
            //       // Complete sign-in.
            //       return resolver.resolveSignIn(multiFactorAssertion)
            //     })
            //     .then(function(userCredential) {
            //       // User successfully signed in with the second factor phone number.
            //     });
            // } else {
            //   // Unsupported second factor.
            // }
          } else if (error.code == "auth/wrong-password") {
            this.$messageError("Sai tên đăng nhập hoặc mật khẩu");
          }
        });
    },
  },
};
</script>

<style scoped>
.form-login {
  height: 100vh;
  color: rgba(255, 255, 255, 0.747);
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.title-login {
  color: white;
}
.background-login {
  background-image: linear-gradient(-90deg, #043d80, #043d80, #02aef0);
  height: 100vh;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}
@media only screen and (max-width: 600px) {
  .form-login {
    padding-top: 10vh;
  }
  .background-login {
    overflow: scroll;
  }
}
.logoPage {
  padding: 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0);
  color: black;
  display: flex;
  align-items: flex-start;
  margin-left: 5rem;
}
.leftPage {
  width: 70vw;
  display: flex;
  justify-content: flex-start;
}
.rightPage {
  width: 30vw;
  height: 100vh;
  background: rgb(223, 223, 223);
}
.formLogin {
  width: 80%;
  margin: auto;
  margin-top: 100px;
}
.rightLogo {
  margin: 10vh auto auto auto;
  width: 50%;
  background: white;
  border-radius: 30%;
}
.loader-enter-active,
.loader-leave-active {
  transition: opacity 0.5s;
}
.loader-enter, .loader-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.titleSlogan {
  float: left;
  font-weight: bold;
  border-bottom: solid 1px rgb(255, 255, 255);
  font-size: 40px;
  color: white;
  margin-bottom: 10px;
  margin-top: 20px;
}
.slogan {
  color: white;
  font-size: 25px;
  margin-bottom: 0;
  margin-top: 10px;
  /* font-weight: bold; */
}
.logoImg {
  border-radius: 30%;
}
.welcomePage {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  align-items: flex-start;
}
.btnLogin {
  background: #1a4e8b !important;
}
</style>
